// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonQuestionPage_button__2xWb6"};